import React from "react"
import "./style.scss"
import { HiOutlineArrowNarrowLeft } from "react-icons/hi"
import Img from "gatsby-image"
import { graphql, Link } from "gatsby"
import SEO from "../../components/seo"
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share"
import FacebookIcon from "@material-ui/icons/Facebook"
import TwitterIcon from "@material-ui/icons/Twitter"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import WhatsAppIcon from "@material-ui/icons/WhatsApp"
import MailOutlineIcon from "@material-ui/icons/MailOutline"

const SocialShare = ({ path, title, head }) => {
  return (
    <div
      className="socialContainer"
      style={{ justifyContent: head && "start", marginBottom: head && "2rem" }}
    >
      <LinkedinShareButton url={`https://wersel.io${path}`}>
        <LinkedInIcon style={{ color: "#0072b1" }} />
      </LinkedinShareButton>
      <FacebookShareButton url={`https://wersel.io${path}`}>
        <FacebookIcon style={{ color: "#4267B2" }} />
      </FacebookShareButton>
      <WhatsappShareButton url={`https://wersel.io${path}`}>
        <WhatsAppIcon style={{ color: "#25D366" }} />
      </WhatsappShareButton>
      <TwitterShareButton url={`https://wersel.io${path}`}>
        <TwitterIcon style={{ color: "#1DA1F2" }} />
      </TwitterShareButton>
      <EmailShareButton url={`https://wersel.io${path}`} subject={title}>
        <MailOutlineIcon style={{ color: "#ff5252" }} />
      </EmailShareButton>
    </div>
  )
}

const Post = ({ data }) => {
  const post = data.markdownRemark
  const {
    author,
    date,
    title,
    cover,
    role,
    authorImage,
    description,
    keywords,
    path,
    slugImage,
  } = post.frontmatter

  return (
    <div className="blog_structure">
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        url={`https://wersel.io${path}`}
        largeImg={cover.childImageSharp.resize.src}
        smallImg={slugImage.childImageSharp.resize.src}
        pageName="blogs"
      />
      <div className="arrow_area">
        <Link to="/blogs">
          <p>
            <HiOutlineArrowNarrowLeft className="mr-2" color="#000000" /> Blog
            Page
          </p>
        </Link>
      </div>
      <div className="blog-title">
        <h1>{title}</h1>
        <SocialShare path={path} title={title} head={true} />
        <Img className="cover-image" fluid={cover.childImageSharp.fluid} />
      </div>
      <div
        className="blog-content"
        dangerouslySetInnerHTML={{ __html: post.html }}
      />
      <hr className="separator" />
      <SocialShare path={path} title={title} />
      <div className="author-section">
        <div className="author">
          <img
            src={authorImage.childImageSharp.fluid.originalImg}
            alt="author"
          />
          <div>
            <h4>{author}</h4>
            <p>{role}</p>
          </div>
        </div>
        <p className="createdAt">{date}</p>
      </div>
    </div>
  )
}
export const postQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        author
        date
        role
        description
        keywords
        category
        authorImage {
          childImageSharp {
            fluid {
              originalImg
            }
          }
        }
        slugImage {
          childImageSharp {
            fluid {
              originalImg
            }
            resize(height: 257, width: 257, fit: FILL, cropFocus: CENTER) {
              src
            }
          }
        }
        cover {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
            resize(height: 630, width: 1200, fit: FILL, cropFocus: CENTER) {
              src
            }
          }
        }
      }
    }
  }
`
export default Post
